import React from "react";
import { useNavigate } from "react-router-dom";

const CaseStudyCard = ({ bgColor, imgSrc, title, description, textColor, projectId }) => {
  const navigate = useNavigate();

  const handleProjectClick = (id) => {
    window.scrollTo(0, 0);

    navigate(`/case-studies/${id}`);
  };

  return (
    <div className="rounded-2xl mb-6 overflow-hidden">
      {/* Desktop view */}
      <div
        className="hidden lg:flex"
        style={{
          background: `linear-gradient(to right, ${bgColor}, #ffffff)`,
        }}
      >
        <div className="w-1/2 p-8">
          <img
            src={imgSrc}
            alt={title}
            className="w-full h-auto object-contain transform transition-transform duration-500 hover:scale-105"
          />
        </div>
        <div
          className="border-r-2 border-gray-400 my-6"
          style={{ borderRightWidth: "0.5px" }}
        ></div>
        <div className="w-1/2 p-14">
          <h1 className={`font-bold text-lg mb-6 ${textColor}`}>{title}</h1>
          <p className="text-gray-800">{description}</p>
          <div
            className="flex justify-end mt-10"
            onClick={() => handleProjectClick(projectId)}
          >
            <button className="text-primary text-sm hover:underline">Read more</button>
          </div>
        </div>
      </div>

      {/* Mobile view */}
      <div
        className="lg:hidden flex flex-col"
        style={{
          background: `linear-gradient(to bottom, ${bgColor}, #ffffff)`,
        }}
      >
        <div className="p-8">
          <img
            src={imgSrc}
            alt={title}
            className="w-full h-auto object-contain rounded-3xl transform transition-transform duration-500 hover:scale-105"
          />
        </div>
        <div className="p-4 relative">
          <div
            className="border-b-2 border-gray-400 mb-4"
            style={{ borderBottomWidth: "0.5px" }}
          ></div>
          <h1 className={`font-bold text-lg mb-6 ${textColor}`}>{title}</h1>
          <p className="text-gray-800">{description}</p>
          <div className="flex justify-end mt-10" onClick={() => handleProjectClick(projectId)}>
            <button className="text-primary text-sm">Read more</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseStudyCard;
